import { Injectable, OnDestroy } from '@angular/core';

import {
    BehaviorSubject,
    Subscription,
} from 'rxjs';

import { AccountManagementService } from './account-management.service';


/**
 * This Service is responsible for determining how the MonitoringPreferenceComponent handles its media subscription section.
 * If Social is provisioned, MonitoringPreferenceComponent should have the media subscription checkbox selected and disabled,
 * along with all media subscriptions.
 */
@Injectable()
export class MediaSubscriptionPreferenceService implements OnDestroy {
    private subscriptions: Subscription[] = [];
    private lockSubscriptionsSubject$ = new BehaviorSubject<boolean>(false);

    public licenses$ = this.accountManagementService.getLicenses();
    public lockSubscriptions$ = this.lockSubscriptionsSubject$.asObservable();

    constructor(
        private accountManagementService: AccountManagementService
    ) {
    }

    ngOnDestroy(): void {
        this.subscriptions?.forEach(sub => sub.unsubscribe());
    }

    lockSubscriptions(enable: boolean) {
        this.lockSubscriptionsSubject$.next(enable);
    }
}
